import { EMPTY_LIST } from '../../../../../../constants/common'

export function getIsListingProfilePhotosMissing({ isInitiated, listing }) {
  return isInitiated && (listing?.photos ?? EMPTY_LIST).length === 0
}
